import { useEffect, useState } from "react";

const KEY = "pluggz.cookie-consent";

export function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    try {
      if (!localStorage.getItem(KEY)) setVisible(true);
    } catch {
      // ignore
    }
  }, []);

  if (!visible) return null;

  const set = (value: "accepted" | "declined") => {
    try { localStorage.setItem(KEY, value); } catch {}
    if (value === "accepted" && typeof window !== "undefined") {
      window.dispatchEvent(new Event("pluggz.consent-accepted"));
    }
    setVisible(false);
  };

  return (
    <div
      role="region"
      aria-label="Cookie consent"
      className="fixed inset-x-0 bottom-0 z-50 border-t border-border bg-background/95 px-6 py-4 backdrop-blur"
    >
      <div className="mx-auto flex max-w-6xl flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-xs text-muted-foreground sm:max-w-xl">
          We use essential cookies to run Pluggz and optional analytics cookies to understand how
          our editorial pages perform. You can change your choice anytime in{" "}
          <a href="/privacy-settings" className="underline">Privacy Settings</a>.
        </p>
        <div className="flex flex-wrap gap-2">
          <button
            onClick={() => set("declined")}
            className="border border-border px-4 py-2 text-[11px] uppercase tracking-widest hover:bg-card"
          >
            Decline
          </button>
          <button
            onClick={() => set("accepted")}
            className="bg-foreground px-4 py-2 text-[11px] uppercase tracking-widest text-background hover:bg-accent"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
